export default __webpack_public_path__ + "static/media/ic_fiji.7329b5b1.svg";